import { render, staticRenderFns } from "./set-permission.vue?vue&type=template&id=19b3354c"
import script from "./set-permission.vue?vue&type=script&lang=ts"
export * from "./set-permission.vue?vue&type=script&lang=ts"
import style0 from "./set-permission.vue?vue&type=style&index=0&id=19b3354c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports